import { ReactNode } from 'react';

import { AppButton } from '../../../forms';

export interface IModalFooterActionsProps {
  mainCTA: {
    startIcon?: ReactNode;
    label: string;
    onClick: () => void;
  };
  otherCTA?: {
    startIcon?: ReactNode;
    label: string;
    onClick: () => void;
  };
}

/**
 * -----------------------------------------------------------------------------
 * It renders a modal footer actions with two buttons
 */
export function ModalFooterActions({
  mainCTA,
  otherCTA,
}: Readonly<IModalFooterActionsProps>) {
  return (
    <div className="modal-footer-actions flex flex-col gap-2 sm:flex-row">
      {otherCTA ? (
        <AppButton
          iconStart={otherCTA?.startIcon}
          onClick={otherCTA.onClick}
          size="small"
          title={otherCTA.label}
          type="outlined"
          variants="danger"
        />
      ) : null}

      {mainCTA ? (
        <AppButton
          iconStart={mainCTA?.startIcon}
          onClick={mainCTA.onClick}
          size="small"
          title={mainCTA.label}
          variants="primary"
        />
      ) : null}
    </div>
  );
}
